// extracted by mini-css-extract-plugin
export default {"toast":"AppMessageNotifier_toast__Ik6oM","badge":"AppMessageNotifier_badge__BJq3k"};